import { render, staticRenderFns } from "./VAvatarMenu.vue?vue&type=template&id=5abb5d5a"
import script from "./VAvatarMenu.vue?vue&type=script&lang=js"
export * from "./VAvatarMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports